<!-- 页面右侧悬浮-咨询入口 -->
<template>
  <div>
      <!-- 右侧悬浮 -->
      <div class="fixedBox">
        <el-popover
          placement="left"
          width="220"
          trigger="hover">
          <div class="telphone">
            <p>联系客服：<a href="tel:4008-717-107">4000-810-510</a></p>
            <p>企业咨询：<a href="tel:0571-8500-1801">186-1208-5556</a></p>
            <span>(周一至周五：09:00-18:00)</span>
          </div>
          <div slot="reference">
            <img src="../../assets/images/img_phone.png" alt="">
            <span>电话咨询</span>
          </div>
        </el-popover>
        <el-popover
          placement="left"
          width="220"
          trigger="hover">
          <div style="text-align:center;">
             <img style="width:127px;height:127px;" class="diaCode" src="../../assets/images/code2.jpg" alt="">
          </div>
          <div slot="reference">
            <img src="../../assets/images/img_message.png" alt="">
            <span>在线咨询</span>
          </div>
        </el-popover>
        <div>
            <img src="../../assets/images/img_book.png" alt="" @click="toPlan">
            <span>获取方案</span>
        </div>
        <div @click="toTop">
          <img class="goUp" src="../../assets/images/img_up.png" alt="">
        </div>
      </div>
  </div>
</template>

<script>
export default {
  data () {
    return {

    }
  },
  methods: {
    toTop () {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth'
      })
    },
    toPlan () {
      this.$router.push('/getPlan')
    }
  },
  created () {
    this.toTop()
  },
  destroyed () {

  }
}
</script>
<style lang="less" scoped>
.fixedBox{
  display: none;
}
// pc端样式
@media only screen and (min-width: 1024px) {
  body{
    font-size:16px;
  }
  /deep/ .el-dialog__body{
    padding: 0;
  }
  /deep/ .el-dialog__header{
    display: none;
  }
  /deep/ .el-popover{
    font-size: 12px;
  }
  .telphone{
    p{
      line-height: 32px;
      a{
        color: #428BF8;
      }
    }
    span{
      font-size: 13px;
      font-weight: 400;
      color: #999999;
      line-height: 18px;
    }
  }
  .fixedBox{
    display: block;
    z-index: 100;
    position: fixed;
    right: 0;
    top: 50%;
    margin-top: -108px;
    display: flex;
    flex-direction: column;
    box-shadow: 0 4px 30px 0 rgb(0 42 88 / 20%);
    background: linear-gradient(211deg, #3EE3FF 0%, #2E9EFD 46%, #1D5DC0 100%);
    border-radius: 10px;
    div{
      position: relative;
      padding: 21px 8px;
      font-size: 12px;
      color: #fff;
      display: flex;
      flex-direction: column;
      align-items: center;
      box-sizing: border-box;
      img{
        width: 35px;
        height: 37px;
      }
      a{
        color: #002fec !important;

      }
      .goUp{
        height: 26px;
        width: 42px;
      }
    }
    div:after {
        content: "";
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        height: 1px;
        background-color: rgba(0,0,0,.2);
    }
    div:hover{
      color: #fff;
      cursor: pointer;
      opacity: 0.6;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/comForPc/sidebar.vue